import { IconName } from '#components';
import { GenericLinkComponent } from '#components/TextLink/TextLink';
import { ReactNode } from 'react';

export enum ButtonSizes {
  M = 'medium',
  S = 'small',
}
export type ButtonSize = 'medium' | 'small';

export enum ButtonVariants {
  TEXT = 'text',
  SOLID = 'solid',
  WRAPPER = 'wrapper',
  LINK = 'link',
}
export type ButtonVariant = 'text' | 'solid' | 'wrapper' | 'link';
export type DeprecatedButtonVariant = 'outline' | 'transparent' | 'tertiary';

export enum ButtonColors {
  GREEN = 'green',
  BLUE = 'blue',
  PURPLE = 'purple',
  ORANGE = 'orange',
  LIGHT_PURPLE = 'lightPurple',
  DARK_PURPLE = 'darkPurple',
  RED = 'red',
  DARK = 'dark',
  GREY = 'grey',
  LIGHT = 'light',
  WHITE = 'white',
}
export type ButtonColor =
  | 'green'
  | 'blue'
  | 'purple'
  | 'orange'
  | 'lightPurple'
  | 'darkPurple'
  | 'red'
  | 'dark'
  | 'grey'
  | 'light'
  | 'white';

export interface ButtonProps {
  label?: string;
  size?: ButtonSize;
  variant?: ButtonVariant | DeprecatedButtonVariant;
  type?: 'button' | 'submit' | 'reset';
  width?: 'content' | 'full';
  color?: ButtonColor;
  className?: string;
  iconNameLeft?: IconName;
  iconNameRight?: IconName;
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
  children?: ReactNode;
  onClick?: (() => Promise<void>) | (() => void);
  hrefTracking?: string;
  isExternalTracking?: boolean;
}

export interface ButtonContentProps {
  loading?: boolean;
  iconNameLeft?: IconName;
  iconNameRight?: IconName;
  children?: ReactNode | string;
  size?: ButtonSize;
}
export interface LinkButtonProps extends ButtonProps {
  href: string | { pathname: string; search?: string };
  state?: { from?: string; tinyAccountId?: string | null };
  external?: boolean;
  linkClassName?: string;
  NavLinkComponent?: GenericLinkComponent;
  navigate?: (url: string, options?: { replace?: boolean }) => void;
  navigateOptions?: { replace?: boolean };
}
